import {EagleApiInterface, EagleModuleApiInterface} from 'kernel/api/api'

export default (api: EagleApiInterface) => {
  api.collection.storeApi = <EagleModuleApiInterface>{
    read: (id: string) => api.request({
      url: `/api/admin/store/${id}`,
      type: 'get',
    }),
    index: (params = {}) => api.request({
      url: `/api/admin/store/index`,
      type: 'get',
      params,
    }),
    create: (params = {}) => api.request({
      url: `/api/admin/store`,
      type: 'post',
      params,
    }),
    update: (id: string, params = {}) => api.request({
      url: `/api/admin/store/${id}/update`,
      type: 'put',
      params,
    }),
    patch: (id: string, column: string, value: any) => api.request({
      url: `/api/admin/store/${id}`,
      type: 'patch',
      params: {
        column,
        value,
      },
    }),
    delete: (id: string) => api.request({
      url: `/api/admin/store/${id}`,
      type: 'delete',
    }),
    batch: (targets: string[], column: string, value: any) => api.request({
      url: `/api/admin/store/batch`,
      type: 'patch',
      params: {
        ids: targets,
        column,
        value,
      },
    }),
    batchDelete: (targets: string[]) => api.request({
      url: `/api/admin/store/batch`,
      type: 'delete',
      params: { ids: targets },
    }),
    bindAdmin: (store_id: string, memberId: string, type: string) => api.request({
      url: `/api/admin/store/${store_id}/master/${memberId}`,
      type: 'put',
      params: { type },
    }),
  }
}
